import Vue from 'vue'

class ChargingPointRepository {
  search(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/search',
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
  markers(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/markers',
        method: 'post',
        data,
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getNotInstalled(imei) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/getNotInstalled/' + imei,
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  // Les interventions des techniciens sur la borne, les plus récentes d'abord : { items }
  interventions(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: `/api/charging-point/${id}/interventions`,
        method: 'get',
      }).then(response => resolve(response.data)).catch(err => reject(err))
    })
  }

  get(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/get/' + id,
        method: 'get',
      })
          .then(response => {
            resolve(response.data)
          }).catch(err => {
        reject(err)
      })
    })
  }

  update(id, data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/update/' + id,
        method: 'post',
        data
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  chargingPointTypes(data) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point-type/search',
        method: 'post',
        data,
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  // Constructeurs › gammes › types qui ont des bornes, avec leur nombre (sélecteurs de recherche)
  classification() {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point-classification',
        method: 'get',
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }



  installChargingPoint(identifier, locationId) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/install',
        method: 'post',
        data: {
          identifier,
          locationId,
        },
      })
      .then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  statusCounter() {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/status-counter',
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  meterDiscontinuities(month) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/meter-discontinuities',
        method: 'get',
        data: {
            month,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  firmware(id) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/' + id + '/firmware',
        method: 'get',
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

  chargingPointMeterDiscontinuities(id, month) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch({
        url: '/api/charging-point/' + id + '/meter-discontinuities',
        method: 'get',
        data: {
            month,
        }
      }).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

}


export default new ChargingPointRepository()
